module.exports = __webpack_public_path__ + "img/share-alt.75852308.svg";